// ─────────────────────────────────────────────────────────────────────────────
// Delivery feature — API давхарга. Гар захиалга (жолооч дуудах) + QPay + түүх.
// ─────────────────────────────────────────────────────────────────────────────
import axios from "axios";
import AxiosRequest, { API_URL } from "shared/api/httpClient";

/** Мерчантын хаяг (ачих хаягийн урьдчилсан утга). */
export async function getMerchantAddress() {
  return AxiosRequest({ url: "/merchant/getMerchantAddress", method: "get" });
}

/** Бүх дүүрэг/байршил. */
export async function getAllDistricts() {
  return AxiosRequest({ url: "/merchant/getAllDistricts", method: "get" });
}

/** Ачааны төрлүүд (хэмжээ). */
export async function getPackageSizes() {
  return AxiosRequest({ url: "/merchant/getPackageSizes", method: "get" });
}

/** Тухайн дүүрэгт ачааны үнэ. */
export async function getPackagePrices(districtId) {
  return AxiosRequest({
    url: `/merchant/getPackagePrices/${districtId}`,
    method: "get",
  });
}

/** Гар захиалга (жолооч дуудах) үүсгэх. */
export async function createManualOrder(body) {
  return AxiosRequest({
    url: `/merchant/create-manual-order`,
    method: "post",
    data: body,
  });
}

/** Гар захиалгын түүх. */
export async function fetchManualOrders(body) {
  return AxiosRequest({
    url: `/merchant/fetchManualOrders`,
    method: "post",
    data: body,
  });
}

// ⚠️ Алдааг null болгож ЗАЛГИХГҮЙ — дуудагчийн try/catch нь "сүлжээ/серверийн
//    алдаа"-г "төлбөр хийгдээгүй"-ээс ялгах ёстой (QrCodeModal).
/** QPay нэхэмжлэл үүсгэх (raw axios — AxiosRequest-ийн interceptor-гүй). */
export async function createQpayInvoice(body) {
  const res = await axios({
    url: `${API_URL}/createMerchantQpayInvoice`,
    method: "post",
    data: body,
  });
  return res.data;
}

/** QPay төлбөр шалгах. */
export async function checkQpayPayment(body) {
  const res = await axios({
    url: `${API_URL}/checkQpayPayment`,
    method: "post",
    data: body,
  });
  return res.data;
}
